import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  tabs?: boolean;
}

export const Wrapper = styled.div`
  /* margin: 57px 0 0 60px;  when filters are added */
  margin: ${(props: IWrapperProps) => (props.tabs ? "0" : "10px 0 0 60px")};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #e4e5e7;
  padding: ${(props: IWrapperProps) =>
    props.tabs ? "0 10px" : "60px 0 10px 0"};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  .animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.tablet} {
    margin: ${(props: IWrapperProps) =>
      props.tabs
        ? "0"
        : "30px 0 0 0"}; // when filters are added change to 57px 0 0 0
    padding: ${(props: IWrapperProps) =>
      props.tabs
        ? "0"
        : "40px 0 10px 0"}; // change this to 80px 0 10px 0 when company filter is added */
  }

  ${mediaMaxWidth.phone} {
    padding: ${(props: IWrapperProps) =>
      props.tabs
        ? "10px 0"
        : "40px 0 10px 0"}; // change this to 80px 0 10px 0 when company filter is added */
  }
`;

interface IInnerProps {
  datePickerActive?: boolean;
  agencyPerformance?: boolean;
}

export const Inner = styled.div`
  display: flex;
  width: ${(props: IInnerProps) =>
    props.agencyPerformance ? "850px" : "1100px"};
  flex-direction: column;
  z-index: ${(props: IInnerProps) => props.datePickerActive && "5"};

  ${mediaMaxWidth.tablet} {
    width: 100vw;
  }
`;

interface IChartsProps {
  isPremiumOrPortalUser?: boolean;
  hubAdminPresent?: boolean;
  agency?: boolean;
}

export const Charts = styled.div`
  display: flex;
  flex-direction: ${(props: IChartsProps) => (props.agency ? "column" : "row")};
  margin: 10px 0;
  opacity: ${(props: IChartsProps) =>
    props.isPremiumOrPortalUser || props.hubAdminPresent ? "1" : "0.5"};
  filter: ${(props: IChartsProps) =>
    !props.isPremiumOrPortalUser &&
    !props.hubAdminPresent &&
    "blur(3px) grayscale(100%)"};

  ${mediaMaxWidth.mediumDesktop} {
    flex-direction: column;
  }

  ${mediaMaxWidth.phone} {
    margin: 0;
  }
`;

interface IChartTitleProps {
  marginBottom?: number;
  pdfExport?: boolean;
}

export const ChartTitle = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props: IChartTitleProps) =>
    props.marginBottom ? `${props.marginBottom}px` : "0"};
  transform: ${(props: IChartTitleProps) => props.pdfExport && "scale(0.75)"};
  width: ${(props: IChartTitleProps) => props.pdfExport && "525px"};
  position: ${(props: IChartTitleProps) => props.pdfExport && "relative"};
  left: ${(props: IChartTitleProps) => props.pdfExport && "-60px"};
`;

export const ChartTitleText = styled.span`
  ${mediaMaxWidth.phone} {
    width: 160px;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
  }
`;

interface IChartGroupProps {
  pdfExport?: boolean;
}

export const ChartGroup = styled.div`
  display: flex;
  height: ${(props: IChartGroupProps) => !props.pdfExport && "480px"};
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  ${mediaMaxWidth.mediumDesktop} {
    height: ${(props: IChartGroupProps) => !props.pdfExport && "unset"};
    width: ${(props: IChartGroupProps) => !props.pdfExport && "690px"};
    margin: ${(props: IChartGroupProps) => !props.pdfExport && "0 auto"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IChartGroupProps) => !props.pdfExport && "100vw"};
  }
`;
